// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__W4KD_","rootCenter":"LoadMoreObserver_rootCenter__1ZOdX","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__VmcZ8"};